import { colors as themeColors } from "@toddle-edu/ds-theme";
const localColors = {
  /* not present in theme */
  strokeOne: "#ebebeb", //colors.borderSubtle
  strokeTwo: "#dbdbdb", //colors.borderDefault
  salmon60: "#f75961", //possibly replace it with colors.red66 everywhere
  warning50: "#ffab00",
  link29: "#008392",

  /* different color hex in theme for same keys */
  iconDefault: "#484848",
  iconDisabled: "#dbdbdb",
};

export const colors = { ...themeColors, ...localColors };

export const colorPalette = [
  colors.seaweed,
  colors.blue400,
  colors.yellow500,
  colors.salmon60,
  colors.blue400,
  colors.violet500,
];

export const fontWeight = {
  AvenirNextMedium: "500",
  AvenirNextDemiBold: "600",
  AvenirNextBold: "bold",
};

export const AVATAR_COLORS = ["violet", "blue", "yellow", "pink", "teal"];

export const AVATAR_COLORS_V2 = [
  "teal",
  "violet",
  "blue",
  "yellow",
  "pink",
  "green",
  "purple",
  "orange",
];

export const PROFILE_AVATAR_COLORS = [
  "neutral",
  "violet",
  "blue",
  "yellow",
  "pink",
];

export const AVATAR_TO_NORMAL_COLORS_MAPPING = {
  violet: colors.violet300,
  blue: colors.blue300,
  yellow: colors.yellow300,
  pink: colors.pink200,
  teal: colors.blue300,
};

export const AVATAR_TO_NORMAL_COLORS_MAPPING_V2 = {
  teal: "var(--decorative-foreground-teal)",
  violet: "var(--decorative-foreground-violet)",
  blue: "var(--decorative-foreground-blue)",
  yellow: "var(--decorative-foreground-yellow)",
  pink: "var(--decorative-foreground-pink)",
  green: "var(--decorative-foreground-green)",
  purple: "var(--decorative-foreground-purple)",
  orange: "var(--decorative-foreground-orange)",
};
